/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCollapseWindow = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5.126 12V4.5h15v14h-8.5V20h8.5s1.5 0 1.5-1.5v-14s0-1.5-1.5-1.5h-15s-1.5 0-1.5 1.5V12z" /><path fill="currentColor" d="M9.626 17c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3M9.626 14h5.833l-1.833-2 3-3-2-2-3 3-2-1.833z" /></svg>;
export default SvgCollapseWindow;